    export const equipmentColors = {
    고급: { background: '#415E1C', border: '#3a5714' },
    희귀: { background: '#14507A', border: '#093758' },
    영웅: { background: '#46185F', border: '#38124d' },
    전설: { background: '#AD7900', border: '#794907' },
    유물: { background: '#A13A00', border: '#a35224' },
    고대: { background: '#C1B085', border: '#61543e' },
  };